import React, { CSSProperties, FC, Fragment, useEffect } from 'react';
import { useTheme } from '../../../hooks/useTheme';

function camelToSpaceCase(str: string) {
  return str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}

function styleObjectToString(style: CSSProperties): string {
  return Object.entries(style)
    .map(([key, value]) => {
      const cssKey = camelToSpaceCase(key);
      return `${cssKey}:${value}`;
    })
    .join(';');
}

const StyledDocumentBody: FC = () => {
  const { documentbodyNoneNone: bodyStyle } = useTheme();

  useEffect(() => {
    if (!bodyStyle) return;

    const styleString = styleObjectToString(bodyStyle);
    const styleElement = document.createElement('style');

    styleElement.innerHTML = `body{${styleString}}`;

    document.head.appendChild(styleElement);
  }, [bodyStyle]);

  return <Fragment />;
};

export default StyledDocumentBody;
